import script from "./EditProjectTeamMember.vue?vue&type=script&setup=true&lang=ts"
export * from "./EditProjectTeamMember.vue?vue&type=script&setup=true&lang=ts"

import "./EditProjectTeamMember.vue?vue&type=style&index=0&id=d6a67b3c&lang=scss&scoped=true"

import exportComponent from "/fides/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6a67b3c"]])

export default __exports__